import environment from '../lib/environment';
import * as environmentType from './environments';

export const platformId = environment === environmentType.PRODUCTION ? 9 : 46;
export const platformName = 'merchant-landing-page';



// WEBPACK FOOTER //
// ./src/config/platformInfo.js